var exports = {
  "Zp": "x620889e6--a662fb--layout",
  "S4": "x620889e6--a662fb--layout--fullwidth",
  "hq": "x620889e6--a662fb--layout--filled",
  "sX": "x620889e6--a662fb--layout-mobile",
};

module.exports = exports;
